import { useEffect } from "react";

import { UserActions } from "~/v2/api/auth";

export const LogoutPage = () => {
  useEffect(() => {
    UserActions.userLogout({ global: true });
  }, []);

  return null;
};

export default LogoutPage;
